import {
    FORMEDIT_SUBMIT_FORM_BEGIN,
    FORMEDIT_SUBMIT_FORM_SUCCESS,
    FORMEDIT_SUBMIT_FORM_FAILURE,
    FORMEDIT_SUBMIT_FORM_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitForm(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: FORMEDIT_SUBMIT_FORM_BEGIN,
      });
  
      let apiurl = '/api/b/form/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/form/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: FORMEDIT_SUBMIT_FORM_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: FORMEDIT_SUBMIT_FORM_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitFormError() {
    return {
      type: FORMEDIT_SUBMIT_FORM_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case FORMEDIT_SUBMIT_FORM_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitFormPending: true,
          submitFormError: null,
        };
  
      case FORMEDIT_SUBMIT_FORM_SUCCESS:
        // The request is success
        return {
          ...state,
          submitFormPending: false,
          submitFormError: null,
        };
  
      case FORMEDIT_SUBMIT_FORM_FAILURE:
        // The request is failed
        return {
          ...state,
          submitFormPending: false,
          submitFormError: action.data.error,
        };
  
      case FORMEDIT_SUBMIT_FORM_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitFormError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/formedit/redux/submitForm.js